import type { BlokFetcherProps, BlokProps } from "@trydig/storyblok";
import { rpc } from "#rpc";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { FeaturedCollectionProducts } from "@/components/ui/sections/FeaturedCollectionProducts";
import type { ProductsRoute } from "@/data/routes/products.route";
import type { FeaturedCollectionProductsStoryblok } from "@/generated/sb/sb-types";
import { checkBlokBackground } from "@/lib/utils/isDarkMode";

const clampLimit = (raw: string | number | undefined) => {
	const n = typeof raw === "number" ? raw : Number(raw ?? 3);
	if (!Number.isFinite(n) || n < 1) return 3;
	return Math.min(12, Math.floor(n));
};

export const featuredCollectionProductsFetcher = async ({
	blok,
}: BlokFetcherProps<FeaturedCollectionProductsStoryblok>) =>
	rpc.products.exploration({
		ids: blok.products,
		categoryId: blok.centraCategory,
		limit: clampLimit(blok.productLimit),
	});

export const featuredCollectionProductsKey = ({
	blok,
}: BlokFetcherProps<FeaturedCollectionProductsStoryblok>) => [
	...(blok.products ?? []),
	blok.centraCategory ?? "",
	String(blok.productLimit ?? 3),
];

export const FeaturedCollectionProductsBlok = ({
	blok,
	data,
}: BlokProps<FeaturedCollectionProductsStoryblok, ProductsRoute["exploration"]>) => {
	const bg = checkBlokBackground(blok);

	return (
		<BlokWrap editable={blok} asChild>
			<FeaturedCollectionProducts
				caption={blok.caption || undefined}
				heading={blok.heading || undefined}
				description={blok.description || undefined}
				asset={blok.asset}
				products={data?.products ?? []}
				bg={bg}
			/>
		</BlokWrap>
	);
};
